import * as filters from '@/filters'
import 'animate.css'
import dayjs from 'dayjs'
import 'driver.js/dist/driver.css'
import _ from 'lodash'
import Vue from 'vue'
import App from './App.vue'
import "./assets/css/base.css"
import router from './router'
import store from './store'
import storage from './utils/localStorage.js'
Vue.prototype.$storage = storage;
Vue.prototype.$_ = _;

import Chat from './components/Chat.vue'
Vue.component('Chat', Chat)

// 全局消费券说明弹窗（正文读取后台配置 c_coupon_desc）
import CouponDescPopup from './components/CouponDescPopup.vue'
Vue.component('CouponDescPopup', CouponDescPopup)

// 引入masonry-瀑布流组件库
import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry);

import CustomeMasonry from './components/CustomeMasonry.js'
Vue.component('CustomeMasonry', CustomeMasonry);

import iView from 'iview'
import 'iview/dist/styles/iview.css'
Vue.use(iView);

Vue.prototype.$EventBus = new Vue();

import GlobalLoading from '@/components/Loading.vue'

// 创建全局 loading 实例
const GlobalLoadingConstructor = Vue.extend(GlobalLoading)
const globalLoadingInstance = new GlobalLoadingConstructor({
  el: document.createElement('div')
})

document.body.appendChild(globalLoadingInstance.$el)

// 挂载全局方法
Vue.prototype.$globalLoading = {
  show(message = '加载中...', showProgress = false) {
    globalLoadingInstance.show({ message, showProgress });
  },
  hide() {
    globalLoadingInstance.hide();
  },
  updateProgress(percent) {
    globalLoadingInstance.updateProgress(percent);
  }
}

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueLazyload from "vue-lazyload"
Vue.use(Viewer);

//>portal-vue引入,实现vue3 teleport
import PortalVue from 'portal-vue'
Vue.use(PortalVue);

const style = document.createElement('style')
style.type = 'text/css'
style.innerHTML = '.viewer-container { z-index: 99999 !important; }'
document.head.appendChild(style)

Viewer.setDefaults({
	Options: {
		"inline": true,
		"button": true,
		"navbar": true,
		"title": true,
		"toolbar": true,
		"tooltip": true,
		"movable": true,
		"zoomable": true,
		"rotatable": true,
		"scalable": true,
		"transition": true,
		"fullscreen": true,
		"keyboard": true,
		"url": "data-source"
	}
});

// Vue.use(VueLazyload)
const loadimage = require('@/assets/images/loading.png')
const errimage = require('@/assets/images/img-err.png')
Vue.use(VueLazyload, {
	loading: loadimage,
	error: errimage,
	listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove', 'mousemove']
})
Object.keys(filters).forEach((key) => {

	Vue.filter(key, filters[key])
})

import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
Vue.prototype.$layer = layer(Vue)

import CustomModal from './components/modal.js'
Vue.prototype.$DModal = CustomModal;

Vue.prototype.$bus = new Vue();

import 'dayjs/locale/zh-cn'
import duration from "dayjs/plugin/duration"
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.locale('zh-cn');

Vue.config.productionTip = false
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
